import { HttpInterceptorFn } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Router } from '@angular/router';
import { inject } from '@angular/core';

export const AuthInterceptor: HttpInterceptorFn = (request, next) => {
  const router = inject(Router);
  const token = sessionStorage.getItem('auth-token') ?? '';

  // Clone da request para adicionar headers
  let authRequest = request;

  // Adiciona o token ao cabeçalho, se existir
  if (token) {
    authRequest = request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  return next(authRequest).pipe(
    catchError((error) => {
      // Ignora erros de parsing em respostas 200 (backend retornou não-JSON)
      if (error.status === 200 && error.message?.includes('parsing')) {
        console.warn('Resposta 200 com conteúdo não-JSON em:', request.url);
        return throwError(() => error);
      }

      // Log detalhado do erro
      console.error('Erro na requisição:', {
        url: request.url,
        status: error.status,
        message: error.message,
        error: error.error
      });

      // Tratamento específico para cada tipo de erro
      switch (error.status) {
        case 401: // Unauthorized
          console.warn('Token inválido ou expirado. Redirecionando para login...');
          clearAuthData();
          router.navigate(['/login'], { 
            queryParams: { returnUrl: router.url } 
          });
          break;

        case 403: // Forbidden
          console.warn('Acesso negado. Permissões insuficientes.');
          break;

        case 404: // Not Found
          console.error('Recurso não encontrado:', request.url);
          break;

        case 500: // Internal Server Error
          console.error('Erro interno do servidor');
          break;

        case 0: // Network Error ou CORS
          console.error('Erro de conexão ou CORS. Verifique o servidor.');
          break;

        default:
          console.error('Erro HTTP:', error.status, error.message);
          break;
      }

      return throwError(() => error);
    })
  );
};

function clearAuthData(): void {
  sessionStorage.removeItem('auth-token');
  sessionStorage.removeItem('shortName');
  sessionStorage.removeItem('roles');
}